"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// a remap to better names (without the redundant "color" in each key)
const colorPalette = {
    black: '#000000',
    white: '#FFFFFF',
    blue01: '#00112D',
    blue02: '#00225A',
    blue03: '#003486',
    blue04: '#0045B3',
    blue05: '#0056E0',
    blue06: '#246FE5',
    blue07: '#4687ED',
    blue08: '#99BBF3',
    blue09: '#CCDDF9',
    blue10: '#D7E3F9',
    gray01: '#141414',
    gray02: '#292929',
    gray03: '#3D3D3D',
    gray04: '#525252',
    gray05: '#666666',
    gray06: '#858585',
    gray07: '#A3A3A3',
    gray08: '#C2C2C2',
    gray085: '#D8D8D8',
    gray09: '#E0E0E0',
    gray10: '#F1F1F1',
    green01: '#062715',
    green02: '#0C4E2A',
    green03: '#127440',
    green04: '#189B55',
    green05: '#1EC26A',
    green06: '#4BCE88',
    green07: '#78DAA6',
    green08: '#A5E7C3',
    green09: '#D2F3E1',
    green10: '#E4F8ED',
    purple01: '#171719',
    purple02: '#2F2E32',
    red01: '#29070A',
    red02: '#510E14',
    red03: '#7A141F',
    red04: '#A21B29',
    red05: '#CB2233',
    red06: '#D83848',
    red07: '#F24D5F',
    red08: '#EAA7AD',
    red09: '#F5D3D6',
    red10: '#FAEAEC',
    yellow01: '#684A18',
    yellow02: '#835D1A',
    yellow03: '#9F701C',
    yellow04: '#BC841C',
    yellow05: '#D9991C',
    yellow06: '#F8AE1A',
    yellow07: '#FBB73F',
    yellow08: '#FEC05A',
    yellow09: '#FFC872',
    yellow10: '#FFD18A',
    yellow11: '#FEEFD1',
    violet01: '#29172F',
    violet02: '#3A1F45',
    violet03: '#4D265C',
    violet04: '#5F2D73',
    violet05: '#73348C',
    violet06: '#8B559F',
    violet07: '#A276B2',
    violet08: '#BA97C5',
    violet09: '#D1B9D8',
    violet10: '#E8DCEC',
    magenta01: '#21121A',
    magenta02: '#3B1A2D',
    magenta03: '#562241',
    magenta04: '#742956',
    magenta05: '#92306C',
    magenta06: '#B23683',
    magenta07: '#C15C97',
    magenta08: '#D07EAB',
    magenta09: '#DD9EBF',
    magenta10: '#E9BED4',
    pink01: '#3E1C22',
    pink02: '#5B2530',
    pink03: '#7A2E3F',
    pink04: '#9B374F',
    pink05: '#BC3F5F',
    pink06: '#DF486F',
    pink07: '#E76782',
    pink08: '#EE8296',
    pink09: '#F49CAA',
    pink10: '#F9B5BE',
    midnight01: '#0D2A58',
    midnight02: '#072F6E',
    midnight03: '#003486',
    midnight04: '#0B49AA',
    midnight05: '#1C5FC8',
    midnight06: '#4079D3',
    midnight07: '#5686D1',
    midnight08: '#8CA7D1',
    midnight09: '#BAC6D9',
    midnight10: '#E0E3E8',
    teal01: '#101D1A',
    teal02: '#15342E',
    teal03: '#184C43',
    teal04: '#17655A',
    teal05: '#127F71',
    teal06: '#009B89',
    teal07: '#4CAC9C',
    teal08: '#74BDAF',
    teal09: '#98CDC2',
    teal10: '#BBDED6',
    orange01: '#29180A',
    orange02: '#4C280F',
    orange03: '#713910',
    orange04: '#994B10',
    orange05: '#C25D0C',
    orange06: '#DD7011',
    orange07: '#FFA95E',
    orange08: '#FFB879',
    orange09: '#FFC693',
    orange10: '#FFD4AE',
    coolgray01: '#0C0C0D',
    coolgray02: '#212124',
    indigo01: '#16132B',
    indigo02: '#2A225E',
    indigo03: '#3C2F8E',
    indigo04: '#4A3DA4',
    indigo05: '#5F50BE',
    indigo06: '#7C6ED8',
    indigo07: '#A297E5',
    indigo08: '#BCB4F0',
    indigo09: '#D9D3FD',
    indigo10: '#E7E3FF',
    offwhite01: '#131318',
    offwhite02: '#26252A',
    offwhite03: '#3A3A3B',
    offwhite04: '#57554E',
    offwhite05: '#6C6862',
    offwhite06: '#8D8B7E',
    offwhite07: '#ABA999',
    offwhite08: '#C8C8BD',
    offwhite085: '#DEDED5',
    offwhite09: '#EBEAE1',
    offwhite10: '#F4F3EE',
};
exports.default = colorPalette;
